import { ArrowUpRight, Check } from "lucide-react";
import { motion } from "framer-motion";
import { track } from "../lib/site";
import { useSite } from "../context/SiteContext";

export const RoomCard = ({ room, index = 0 }) => {
  const { openBooking } = useSite();
  return (
    <motion.article
      className="room-card"
      initial={{ opacity: 0, y: 34 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.75, delay: (index % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`room-card-${room.id}`}
    >
      <div className="room-image-wrap">
        {room.image ? (
          <img src={room.image} alt={room.name} loading="lazy" />
        ) : (
          <div className="room-photo-placeholder">
            <span>M</span>
            <p>Photograph on its way</p>
          </div>
        )}
        <span className="room-number">{String(index + 1).padStart(2, "0")}</span>
        <span className="room-tag">{room.category}</span>
      </div>
      <div className="room-body">
        <div className="room-title">
          <h3>{room.name}</h3>
          <span className="rate">{room.rate}<small>/ night</small></span>
        </div>
        <p>{room.summary}</p>
        <div className="room-meta"><span>{room.guests}</span><span>{room.bed}</span></div>
        <div className="amenities">
          {room.amenities.map((amenity) => <span key={amenity}><Check size={13} /> {amenity}</span>)}
        </div>
        <button
          className="gold-button room-book-btn"
          onClick={() => { track("book_now_click", { location: "room_card", room: room.name }); openBooking({ room }); }}
          data-testid={`room-book-${room.id}`}
        >
          Book now <ArrowUpRight size={15} />
        </button>
      </div>
    </motion.article>
  );
};
